import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../../config/axios';

const ProtectedRoute = ({ children, path }) => {
  const [hasAccess, setHasAccess] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    checkAccess();
  }, [path]);

  const checkAccess = async () => {
    try {
      if (path === '/dashboard' || path === '/usuarios') {
        setHasAccess(true);
        setLoading(false);
        return;
      }

      const response = await api.get('/me');
      const userData = response.data;
      
      if (!userData.gestora_designacao_id && !userData.unidade_designacao_id) {
        setHasAccess(true);
        setLoading(false);
        return;
      }

      const menusResponse = await api.get('/menus');
      const menusUsuario = menusResponse.data;
      
      if (!menusUsuario || menusUsuario.length === 0) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      const temAcesso = menusUsuario.some(menu => {
        if (menu.rota === path) {
          return true;
        }
        
        if (path.startsWith(menu.rota + '/')) {
          return true;
        }
        
        if (menu.submenus) {
          return menu.submenus.some(subMenu => {
            if (subMenu.rota === path) {
              return true;
            }
            if (path.startsWith(subMenu.rota + '/')) {
              return true;
            }
            return false;
          });
        }
        
        return false;
      });
      
      setHasAccess(temAcesso);
      setLoading(false);
    } catch (error) {
      setHasAccess(false);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}></div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;